import Login from "./view/Login";
import Register from "./view/Register";
import About from "./view/user/About";
import Blogs from "./view/user/Blogs";
import Cart from "./view/user/Cart";
import Categories from "./view/user/Categories";
import Contact from "./view/user/Contact";
import Home from "./view/user/Home";
import Pay from "./view/user/Pay";
import Product from "./view/user/Product";
import MyOrder from "./view/user/MyOrder";
import Information from "./view/user/Information";

import ProductA from "./view/admin/Product";
import CategoriesA from "./view/admin/Categories";
import BrandA from "./view/admin/Brand";
import OrderA from "./view/admin/Orders";
import CustomersA from "./view/admin/Customers";
import OrderDetailA from "./view/admin/OrderDetail";
import Dashboard from "./components/admin/Dashboard";

export const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/register", component: Register },
];

export const userRoutes = [
  { path: "/", component: Home },
  { path: "/about-us", component: About },
  { path: "/categories", component: Categories },
  { path: "/blogs", component: Blogs },
  { path: "/contact-us", component: Contact },
  { path: "/product/:id", component: Product },
  { path: "/pay", component: Pay },
  { path: "/cart", component: Cart },
  { path: "/my-order", component: MyOrder },
  { path: "/infomation", component: Information },
];

export const adminRoutes = [
  { path: "/admin/dashboard", component: Dashboard },
  { path: "/admin/customers", component: CustomersA },
  { path: "/admin/categories", component: CategoriesA },
  { path: "/admin/brand", component: BrandA },
  { path: "/admin/product", component: ProductA },
  { path: "/admin/order", component: OrderA },
  { path: "/admin/order-detail/:id", component: OrderDetailA },
];
